import { memo } from 'react';
import Grid, { IGridProps } from '../Grid';
import Checkbox from '../Checkbox';
import FormControlLabel from '../FormControl/components/FormControlLabel';
import Slider from '../Slider';
import Typography from '../Typography';
import { B1 } from '../../theme';
import { IPasswordGeneratorPropsFromHook } from '../../hooks/usePasswordGenerator';

export interface IPasswordGeneratorLocalization {
  numberOfCharactersText?: string;
  numbersCheckboxLabel?: string;
  lettersCheckboxLabel?: string;
  specialCharactersCheckboxLabel?: string;
}

export interface IPasswordGeneratorProps extends IPasswordGeneratorPropsFromHook {
  localization?: IPasswordGeneratorLocalization;
  containerGridProps?: IGridProps;
}

const LABEL_SX = {
  whiteSpace: 'nowrap',
};

const LAST_FORM_CONTROL_SX = {
  marginRight: 0,
  ...LABEL_SX,
};

const PasswordGenerator = (props: IPasswordGeneratorProps) => {
  const {
    containerGridProps,
    handleAreLettersAllowedChange,
    handleAreNumbersAllowedChange,
    handleAreSpecialCharactersAllowedChange,
    areLettersAllowed,
    areSpecialCharactersAllowed,
    handleNumberOfCharactersChange,
    numberOfCharacters,
    areNumbersAllowed,
    localization = {},
  } = props;

  const {
    numberOfCharactersText = 'Number of characters',
    lettersCheckboxLabel = 'A-Z',
    specialCharactersCheckboxLabel = '@!#',
    numbersCheckboxLabel = '0-9',
  } = localization;

  return (
    <Grid {...containerGridProps}>
      <Grid item container alignItems="center">
        <Typography variant="subtitle2">{numberOfCharactersText}</Typography>
        :
        &nbsp;
        <Typography color={B1} variant="subtitle1">{numberOfCharacters}</Typography>
      </Grid>

      <Grid item container mt={1} px={1}>
        <Slider
          onChange={handleNumberOfCharactersChange}
          value={numberOfCharacters}
          min={6}
          max={72}
        />
      </Grid>
      <Grid item container justifyContent="space-between">
        <FormControlLabel
          sx={LABEL_SX}
          control={(
            <Checkbox
              disabled={!areSpecialCharactersAllowed && !areLettersAllowed}
              checked={areNumbersAllowed}
              onChange={handleAreNumbersAllowedChange}
            />
          )}
          label={numbersCheckboxLabel}
        />
        <FormControlLabel
          sx={LABEL_SX}
          control={(
            <Checkbox
              disabled={!areSpecialCharactersAllowed && !areNumbersAllowed}
              checked={areLettersAllowed}
              onChange={handleAreLettersAllowedChange}
            />
          )}
          label={lettersCheckboxLabel}
        />
        <FormControlLabel
          sx={LAST_FORM_CONTROL_SX}
          control={(
            <Checkbox
              disabled={!areLettersAllowed && !areNumbersAllowed}
              checked={areSpecialCharactersAllowed}
              onChange={handleAreSpecialCharactersAllowedChange}
            />
          )}
          label={specialCharactersCheckboxLabel}
        />
      </Grid>
    </Grid>
  );
};

export default memo(PasswordGenerator);
